import _ from 'underscore';
import Backbone from 'backbone';
import { APPLY_USERINPUT_TYPES, CONTEXTUAL_ENTITY_TYPE } from '@bingads-webui-campaign/recommendation-core';
import {
  withContextualAttributeTemplate,
  showContextualAttribute,
  hideContextualAttribute,
  prependAccountAttribute,
} from '@bingads-webui-campaign/recommendation-contextual-attribute';

import template from '../template/index.pug';

export default class RepairKeywordsInlineView extends Backbone.View {
  /**
   * @param {Object} data - recommandation data
   * @param {Object} deps - legacy dependencies
   * @param {Object} i18n - i18n object
   * @return {void} void
   */
  initialize({
    data,
    deps,
    i18n,
    router,
    isMCC,
    gridView,
    readOnly,
    gridService,
  }) {
    this.data = data;
    this.deps = deps;
    this.i18n = i18n;
    this.router = router;
    this.isMCC = isMCC;
    this.readOnly = readOnly;
    this.grid = { gridView };
    this.gridService = gridService;
  }

  get events() {
    return {
      'click .apply': this.apply,
      'click .cancel': this.cancel,
      'mouseover .recommendation-repair-keywords-inline-view .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .recommendation-repair-keywords-inline-view .contextual-tooltip': 'hideContextualAttributePopup',
      'click .recommendation-repair-keywords-inline-view .contextual-tooltip': 'scopeRouting',
    };
  }

  scopeRouting(e) {
    this.router(e);
  }

  hideContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    hideContextualAttribute({ e, self: this });
  }

  showContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    this.timerForPopupContextualAttribute = setTimeout(() => {
      showContextualAttribute({
        deps: this.deps,
        i18n: this.i18n,
        e,
        type: this.data.OpportunityType,
        isExpanding: true,
        self: this,
        recommendationService: this.gridService.recommendationService,
      });
    }, 500);
  }

  render() {
    const params = {
      i18n: this.i18n,
      getEntity: this.getEntity,
      readOnly: this.readOnly,
    };

    this.$el.html(template(params));

    this.createKeywordView = new this.deps.CreateKeywordView({
      adGroup: {
        adGroupId: this.data.Target.AdGroupId,
        campaignId: this.data.Target.CampaignId,
      },
    });

    this.$('.create-keyword-container').html(this.createKeywordView.render().el);
    return this;
  }

  apply() {
    const keywords = this.createKeywordView.getKeywords();
    if (!_.isEmpty(keywords)) {
      const keywordSuggestionsAdded = this.createKeywordView.getSuggestionsAdded();
      const newKeywords = _.map(keywords, keyword => ({
        KeywordText: keyword.Text,
        MatchType: keyword.MatchType,
        IsKP: _.contains(keywordSuggestionsAdded, keyword.Text),
      }));
      this.trigger('apply', {
        opportunities: this.data.Opportunities,
        userInputs: [{
          '@odata.type': APPLY_USERINPUT_TYPES[this.data.OpportunityType],
          NewKeywords: newKeywords,
          OpportunityId: _.first(this.data.Opportunities).OpportunityId,
        }],
      });
    }
  }

  cancel() {
    this.trigger('cancel');
    this.createKeywordView.cancel();
  }

  hasChanged() {
    const keywords = this.createKeywordView.getKeywords();
    return _.size(keywords) > 0;
  }

  getEntity = () => {
    const entity = this.data.Target.AdGroupName ? `${withContextualAttributeTemplate({
      opportunityId: this.data.Opportunities ?
        this.data.Opportunities[0].OpportunityId :
        this.data.OpportunityId,
      entityName: this.data.Target.CampaignName,
      entityId: this.data.Target.CampaignId,
      entityType: CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
      status: 'false',
      isExpandingView: true,
      ariaLabel: this.i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: this.data.Target.CampaignName }),
    })} > ${withContextualAttributeTemplate({
      opportunityId: this.data.Opportunities ?
        this.data.Opportunities[0].OpportunityId :
        this.data.OpportunityId,
      entityName: this.data.Target.AdGroupName,
      entityId: this.data.Target.AdGroupId,
      entityType: CONTEXTUAL_ENTITY_TYPE.ADGROUP,
      entityCampaignId: this.data.Target.CampaignId,
      status: 'false',
      isExpandingView: true,
      ariaLabel: this.i18n.getString('Click to scope to ad group {{adGroupName}}', { adGroupName: this.data.Target.AdGroupName }),
    })}` :
      withContextualAttributeTemplate({
        opportunityId: this.data.Opportunities ?
          this.data.Opportunities[0].OpportunityId :
          this.data.OpportunityId,
        entityName: this.data.Target.CampaignName,
        entityId: this.data.Target.CampaignId,
        entityType: CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
        status: 'false',
        isExpandingView: true,
        ariaLabel: this.i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: this.data.Target.CampaignName }),
      });

    return {
      entity_name: this.isMCC ? prependAccountAttribute({
        opportunityId: this.data.Opportunities ?
          this.data.Opportunities[0].OpportunityId :
          this.data.OpportunityId,
        accountId: this.data.Target.AccountId,
        accountName: this.data.Target.AccountName,
        originEntity: entity,
      }) : entity,
    };
  };
}
